import React, {Component} from 'react';
import './App.css';
import {CardList} from './components/card-list/card-list.component';
import {SearchBox} from './components/search-box/search-box.component'

class App extends Component{
    constructor(){
      super();

      this.state ={

        puppys:[ ],
        searchField:''
      }
    }

  

    
    componentDidMount(){
       fetch('https://jsonplaceholder.typicode.com/users')
       .then(response=>response.json())
       .then(users=>this.setState({puppys:users}))
    }
    render(){
      const {puppys,searchField}= this.state;
      const filterdPuppys= puppys.filter(puppy => puppy.name.toLowerCase().includes(searchField.toLowerCase()));

      return(
        <div className='App'>
          <h1>Kitty World!</h1>
          <SearchBox placeholder='Search' handleChange={e => this.setState({searchField:e.target.value} )}/>
          <CardList puppys={filterdPuppys}/>
          
        </div>
      )
    }

}

export default App;
